import { ResidenceType } from '/@/modules/asset/enums/ResidenceType';
import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step541360Meta extends BaseModel {
  /**
   * @var {?bool}
   */
  hasOwnRealEstate;

  /**
   * @var {?bool}
   */
  hasRentedRealEstate;

  /**
   * @var {ResidenceType[]}
   */
  ownedRealEstateTypes;

  /**
   * @var {ResidenceType[]}
   */
  rentedRealEstateTypes;

  /**
   * @var {?number}
   */
  secondaryResidenceCount;

  /**
   * @var {?number}
   */
  investmentEstateCount;

  /**
   * @var {?number}
   */
  commercialInvestmentEstateCount;

  /**
   * @var {?number}
   */
  rentedSecondaryEstateCount;

  /**
   * @var {?number}
   */
  rentedInvestmentEstateCount;

  /**
   * @var {?number}
   */
  rentedCommercialInvestmentEstateCount;

  constructor(model = {}) {
    super();
    this.hasOwnRealEstate = model.hasOwnRealEstate;
    this.hasRentedRealEstate = model.hasRentedRealEstate;
    this.ownedRealEstateTypes = model.ownedRealEstateTypes ?? [];
    this.rentedRealEstateTypes = model.rentedRealEstateTypes ?? [];
    this.investmentEstateCount = model.investmentEstateCount;
    this.commercialInvestmentEstateCount = model.commercialInvestmentEstateCount;
    this.secondaryEstateCount = model.secondaryEstateCount;
    this.rentedSecondaryEstateCount = model.rentedSecondaryEstateCount;
    this.rentedInvestmentEstateCount = model.rentedInvestmentEstateCount;
    this.rentedCommercialInvestmentEstateCount = model.rentedCommercialInvestmentEstateCount;
  }

  getOwnedResidenceCountKey(key) {
    if (key === ResidenceType.SECONDARY.key) {
      return 'secondaryEstateCount';
    }
    if (key === ResidenceType.RESIDENTIAL_INVESTMENT.key) {
      return 'investmentEstateCount';
    }
    return 'commercialInvestmentEstateCount';
  }

  getRentedResidenceCountKey(key) {
    if (key === ResidenceType.SECONDARY.key) {
      return 'rentedSecondaryEstateCount';
    }
    if (key === ResidenceType.RESIDENTIAL_INVESTMENT.key) {
      return 'rentedInvestmentEstateCount';
    }
    return 'rentedCommercialInvestmentEstateCount';
  }

  isPrimaryResidence(value) {
    return value === ResidenceType.PRIMARY.key;
  }

  resetOwnedResidences() {
    this.ownedRealEstateTypes = [];
    this.secondaryEstateCount = 0;
    this.investmentEstateCount = 0;
    this.commercialInvestmentEstateCount = 0;
  }

  resetRentedResidences() {
    this.rentedRealEstateTypes = [];
    this.rentedSecondaryEstateCount = 0;
    this.rentedInvestmentEstateCount = 0;
    this.rentedCommercialInvestmentEstateCount = 0;
  }

  /**
   * @returns {boolean}
   */
  hasOwnPrimaryRealEstate() {
    return this.hasOwnRealEstate && this.ownedRealEstateTypes.includes(ResidenceType.PRIMARY.key);
  }
}
